// extracted by mini-css-extract-plugin
export default {"courseContainer":"MyCourse_courseContainer__smf7F"};